var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMood4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 477.14 887.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a0c438;}.cls-2{fill:#b9d664;}.cls-3{fill:#86a822;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 25.58,
    y: 621.01,
    width: 434.4,
    height: 47.23,
    rx: 23.61,
    transform: "translate(485.56 1289.25) rotate(180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 238.57,
    cy: 238.57,
    r: 230.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M238.57,477.14c131.55,0,238.57-107,238.57-238.57S370.12,0,238.57,0,0,107,0,238.57,107,477.14,238.57,477.14Zm0-460.4c122.32,0,221.84,99.51,221.84,221.83S360.89,460.41,238.57,460.41,16.74,360.89,16.74,238.57,116.25,16.74,238.57,16.74Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 327.98,
    cy: 181.02,
    r: 29.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 160.67,
    cy: 181.02,
    r: 29.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M237.61,359.76A120.1,120.1,0,0,0,350.29,282.6a8.63,8.63,0,1,0-16.09-6.24,103.59,103.59,0,0,1-193.17,0,8.63,8.63,0,1,0-16.09,6.24A120.08,120.08,0,0,0,237.61,359.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.32,866.36H265.88V885H230.32V866.36H173.94V843.07l46.13-66.78h37.58l-41,61.65H231.4V821.33h34.48v16.61h14.44Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMood4);
export default __webpack_public_path__ + "static/media/mood-4.a00d5650.svg";
export { ForwardRef as ReactComponent };